(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65],{

/***/ 28208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signin",
      function () {
        return __webpack_require__(25787);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ ErrorAnnouncement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34954);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);




function ErrorAnnouncement(param) {
    var title = param.title, list = param.list, noShadow = param.noShadow, useTriangleIcon = param.useTriangleIcon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "rounded-md bg-red-100 p-4 ".concat(!noShadow && "shadow-md", " mb-2"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex-shrink-0",
                    children: useTriangleIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "h-5 w-5 text-error-600",
                        "aria-hidden": "true"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "h-5 w-5 text-error-600",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "ml-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-base font-medium text-passport ",
                            children: title
                        }),
                        list && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-2 text-base text-gray-600",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                role: "list",
                                className: "list-disc pl-5 space-y-1",
                                children: list === null || list === void 0 ? void 0 : list.map(function(e) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: e
                                    }, e);
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 98451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SkipperTextLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_base_elements_SkipperLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61278);




function SkipperTextLogo(param) {
    var _href = param.href, href = _href === void 0 ? "/auth/signin" : _href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center cursor-pointer",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_elements_SkipperLogo__WEBPACK_IMPORTED_MODULE_3__/* .SkipperLogo */ .j, {
                    className: "w-12 h-12 fill-current text-teal-600 mr-2 transform scale-110"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-4xl text-passport font-bold font-inter",
                    children: "Skipper"
                })
            ]
        })
    });
}


/***/ }),

/***/ 93997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wave; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function Wave(param) {
    var className = param.className;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute top-32 bottom-0 right-0 left-0 z-0", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 1440 640",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "none",
        className: classNames,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M473 15.9267C217.959 37.5808 116 31.8926 0 20.7249V640H1440V7.72198C1363 20.7249 915 -21.6011 473 15.9267Z",
            fill: "#e8f6f8",
            fillOpacity: "1"
        })
    });
}


/***/ }),

/***/ 25787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Signin; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/base/index.ts + 4 modules
var base = __webpack_require__(34867);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(75536);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 106 modules
var motion = __webpack_require__(55123);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/common/svgs/WaveSVG.tsx
var WaveSVG = __webpack_require__(93997);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63397);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 26 modules
var yup_es = __webpack_require__(65413);
// EXTERNAL MODULE: ./graphql/graphql-client/graphClient.ts
var graphClient = __webpack_require__(52789);
;// CONCATENATED MODULE: ./components/common/svgs/GoogleSVG.tsx


function GoogleSVG() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "85",
        height: "26",
        viewBox: "0 0 85 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.16 7.592C35.928 7.592 33.624 10.072 33.624 13.4C33.624 16.728 35.928 19.208 39.192 19.208C42.344 19.208 44.28 17.256 44.28 14.008V13.256H39.384V14.616H42.744C42.68 16.824 41.24 17.848 39.192 17.848C36.792 17.848 35.144 15.944 35.144 13.4C35.144 10.84 36.792 8.952 39.144 8.952C41 8.952 42.056 9.832 42.52 11.128H44.136C43.512 8.968 41.8 7.592 39.16 7.592ZM49.5931 10.76C47.1771 10.76 45.4971 12.52 45.4971 14.968C45.4971 17.416 47.1771 19.176 49.5931 19.176C51.9931 19.176 53.6731 17.416 53.6731 14.968C53.6731 12.52 51.9931 10.76 49.5931 10.76ZM49.6091 12.04C51.2091 12.04 52.2491 13.288 52.2491 14.968C52.2491 16.632 51.2091 17.896 49.6091 17.896C47.9931 17.896 46.9211 16.632 46.9211 14.968C46.9211 13.288 47.9931 12.04 49.6091 12.04ZM59.0306 10.76C56.6146 10.76 54.9346 12.52 54.9346 14.968C54.9346 17.416 56.6146 19.176 59.0306 19.176C61.4306 19.176 63.1106 17.416 63.1106 14.968C63.1106 12.52 61.4306 10.76 59.0306 10.76ZM59.0466 12.04C60.6466 12.04 61.6866 13.288 61.6866 14.968C61.6866 16.632 60.6466 17.896 59.0466 17.896C57.4306 17.896 56.3586 16.632 56.3586 14.968C56.3586 13.288 57.4306 12.04 59.0466 12.04ZM71.7519 10.936H68.8239C68.4719 10.824 68.0879 10.76 67.6719 10.76C65.7839 10.76 64.5679 11.992 64.5679 13.656C64.5679 14.28 64.7439 14.856 65.0799 15.32C64.6159 15.672 64.2479 16.232 64.2479 16.968C64.2479 17.784 64.7759 18.376 65.3199 18.648C64.8559 18.904 64.4399 19.336 64.4399 20.104C64.4399 21.688 65.6719 22.616 67.9599 22.616C70.0239 22.616 71.3199 21.608 71.3199 19.896C71.3199 18.552 70.4879 17.704 68.7759 17.704H66.6319C66.0239 17.704 65.6079 17.416 65.6079 16.888C65.6079 16.536 65.7519 16.264 65.9439 16.088C66.4079 16.36 66.9999 16.52 67.6719 16.52C69.5439 16.52 70.7439 15.256 70.7439 13.656C70.7439 13.096 70.5999 12.584 70.3599 12.152H71.7519V10.936ZM67.6559 15.304C66.5999 15.304 65.9279 14.584 65.9279 13.656C65.9279 12.696 66.5839 11.976 67.6559 11.976C68.7279 11.976 69.3839 12.696 69.3839 13.656C69.3839 14.584 68.7279 15.304 67.6559 15.304ZM66.9679 18.92H68.5039C69.3999 18.92 69.9599 19.208 69.9599 19.96C69.9599 20.92 69.2079 21.4 67.9599 21.4C66.5999 21.4 65.7999 20.936 65.7999 20.056C65.7999 19.272 66.3599 18.952 66.9679 18.92ZM74.2323 19V7.32H72.8563V19H74.2323ZM83.5335 14.856C83.5335 12.136 81.9815 10.76 79.8695 10.76C77.5175 10.76 75.9815 12.552 75.9815 14.984C75.9815 17.528 77.5975 19.176 79.8695 19.176C81.7255 19.176 82.9735 18.184 83.4535 16.584H82.0775C81.7575 17.432 80.9735 17.896 79.9015 17.896C78.5255 17.896 77.5175 17 77.4215 15.512H83.5335V14.856ZM77.4215 14.28C77.5815 12.984 78.4935 12.04 79.8695 12.04C81.2135 12.04 82.1255 12.904 82.1415 14.28H77.4215Z",
                fill: "#0A2545"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9873 14.2247C22.9873 13.2414 22.909 12.5239 22.7397 11.7798H11.7285V16.2178H18.1918C18.0616 17.3207 17.3579 18.9816 15.7942 20.0977L15.7722 20.2463L19.2538 22.9965L19.495 23.021C21.7102 20.9349 22.9873 17.8654 22.9873 14.2247Z",
                fill: "#4285F4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.7289 25.9173C14.8954 25.9173 17.5537 24.8543 19.4954 23.0207L15.7945 20.0973C14.8042 20.8016 13.475 21.2932 11.7289 21.2932C8.62755 21.2932 5.99531 19.2071 5.05698 16.3237L4.91945 16.3356L1.2993 19.1925L1.25195 19.3267C3.18052 23.2332 7.14195 25.9173 11.7289 25.9173Z",
                fill: "#34A853"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.05695 16.3238C4.80937 15.5797 4.66608 14.7824 4.66608 13.9586C4.66608 13.1347 4.80937 12.3375 5.04393 11.5934L5.03737 11.4349L1.37185 8.53223L1.25192 8.59039C0.457066 10.2115 0.000976562 12.0319 0.000976562 13.9586C0.000976562 15.8853 0.457066 17.7056 1.25192 19.3267L5.05695 16.3238Z",
                fill: "#FBBC05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.7289 6.62403C13.9311 6.62403 15.4166 7.59402 16.2637 8.40461L19.5735 5.10928C17.5407 3.1826 14.8954 2 11.7289 2C7.14195 2 3.18052 4.68406 1.25195 8.59056L5.04396 11.5936C5.9953 8.7102 8.62754 6.62403 11.7289 6.62403Z",
                fill: "#EB4335"
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/common/svgs/EyeconSVG.tsx
var EyeconSVG = __webpack_require__(78627);
// EXTERNAL MODULE: ./components/common/svgs/EyeconClosedSVG.tsx
var EyeconClosedSVG = __webpack_require__(87310);
// EXTERNAL MODULE: ./components/common/error/ErrorAnnouncement.tsx
var ErrorAnnouncement = __webpack_require__(5982);
// EXTERNAL MODULE: ./components/common/header/SkipperTextLogo.tsx
var SkipperTextLogo = __webpack_require__(98451);
// EXTERNAL MODULE: ./utils/encodeQueryData.ts
var encodeQueryData = __webpack_require__(13471);
// EXTERNAL MODULE: ./components/context/UniversalModalContext.tsx
var UniversalModalContext = __webpack_require__(47614);
// EXTERNAL MODULE: ../../packages/ui/index.ts + 61 modules
var ui = __webpack_require__(23357);
;// CONCATENATED MODULE: ./pages/auth/signin/index.tsx























var signInValidation = yup_es/* object */.Ry().shape({
    email: yup_es/* string */.Z_().required("Email or Username is required"),
    password: yup_es/* string */.Z_().required("Password is required"),
    rememberMe: yup_es/* bool */.Xg()
});
function handleError(fieldName, formik) {
    var error = formik.touched[fieldName] && formik.errors[fieldName] ? formik.errors[fieldName] : undefined;
    return error;
}
function groupErrors() {
    for(var _len = arguments.length, mutateError = new Array(_len), _key = 0; _key < _len; _key++){
        mutateError[_key] = arguments[_key];
    }
    var hasError = false;
    var errorsList = [];
    mutateError.forEach(function(e) {
        if (e.isError) {
            hasError = true;
            errorsList.push(e.errors);
        }
    });
    return {
        hasError: hasError,
        errorsList: errorsList
    };
}
var AUTH_URL = "https://next.skipper.io";
function Signin() {
    var ref, ref1;
    var ref2 = (0,react.useState)(false), showPassword = ref2[0], setShowPassword = ref2[1];
    var dispatchNotification = (0,UniversalModalContext/* useUniversalModalDispatch */.Xt)().dispatchNotification;
    var ref3 = (0,react.useState)(false), hover = ref3[0], setHover = ref3[1];
    var router = (0,next_router.useRouter)();
    var queryClient = (0,es.useQueryClient)();
    var ref4 = (0,react.useState)(), emailServerError = ref4[0], setEmailServerError = ref4[1];
    var ref5 = (0,react.useState)(), passwordServerError = ref5[0], setPasswordServerError = ref5[1];
    var error = router.query.error;
    (0,react.useEffect)(function() {
        if (router.query.message) {
            var ref;
            var message = Array.isArray(router.query.message) ? (ref = router.query.message) === null || ref === void 0 ? void 0 : ref[0] : router.query.message;
            if (message.toLowerCase() === "success") {
                router.replace("/");
            }
        } else if (router.query.notice) {
            dispatchNotification({
                title: router.query.notice.toString(),
                text: "",
                type: "success"
            });
            router.replace(router.pathname, undefined, {
                shallow: true
            });
        }
    }, [
        router
    ]);
    var mutate = (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var email, password, rememberMe, body, _tmp, resp, _tmp1, jbody;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = param.email, password = param.password, rememberMe = param.rememberMe;
                        _tmp = {};
                        body = JSON.stringify((_tmp.email = email, _tmp.password = password, _tmp.rememberMe = rememberMe, _tmp));
                        _tmp1 = {};
                        return [
                            4,
                            fetch("/api/signin", (_tmp1.method = "POST", _tmp1.headers = {
                                "Content-Type": "application/json"
                            }, _tmp1.body = body, _tmp1))
                        ];
                    case 1:
                        resp = _state.sent();
                        return [
                            4,
                            resp.json()
                        ];
                    case 2:
                        jbody = _state.sent();
                        if (resp.ok) {
                            return [
                                2,
                                jbody
                            ];
                        }
                        throw jbody;
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSettled: function() {
            queryClient.invalidateQueries([
                "session"
            ]);
        },
        onSuccess: function(data) {
            router.push("/");
        },
        onError: function(param) {
            var errors = param.errors;
            var ref;
            var ref1;
            var er = (ref1 = errors === null || errors === void 0 ? void 0 : (ref = errors[0]) === null || ref === void 0 ? void 0 : ref.message) !== null && ref1 !== void 0 ? ref1 : "something went wrong";
            if (er === "Invalid email or password") {
                setEmailServerError("Invalid email or username");
                setPasswordServerError("or invalid password");
            }
        }
    });
    var signinOauth = (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var type, provider, _params, params, _tmp, queryString, _tmp1, _tmp2, response, _tmp3, jsonResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        type = param.type, provider = param.provider, _params = param.params, params = _params === void 0 ? _tmp : _params;
                        _tmp1 = {};
                        _tmp2 = {};
                        queryString = (0,encodeQueryData/* encodeQueryData */.X)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp1, params), (_tmp2.callbackUrl = "/auth/signin", _tmp2)));
                        _tmp3 = {};
                        return [
                            4,
                            fetch("".concat(AUTH_URL, "/api/auth/").concat(type, "/").concat(provider).concat(queryString), (_tmp3.method = "POST", _tmp3.mode = "no-cors", _tmp3.redirect = "follow", _tmp3))
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        jsonResponse = _state.sent();
                        if (!response.ok) {
                            throw jsonResponse;
                        }
                        return [
                            2,
                            jsonResponse
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSettled: function(data) {
            if (data === null || data === void 0 ? void 0 : data.authUrl) {
                window.location.href = data.authUrl;
            }
        },
        onError: function() {
            dispatchNotification({
                title: "OAuth Provider Error",
                text: "Unable to signin with provider",
                type: "danger"
            });
        }
    });
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            email: "",
            password: "",
            rememberMe: true
        },
        onReset: function() {
            setEmailServerError(undefined);
            setPasswordServerError(undefined);
        },
        onSubmit: function(param) {
            var email = param.email, password = param.password, rememberMe = param.rememberMe;
            setEmailServerError(undefined);
            setPasswordServerError(undefined);
            (0,graphClient/* refreshClient */.kT)();
            mutate.mutate({
                email: email.trim(),
                password: password.trim(),
                rememberMe: rememberMe
            });
        },
        validationSchema: signInValidation
    });
    var container = (0,react.useRef)(null);
    var Eyecon = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute right-0 top-0 bottom-0 flex items-center pr-4",
        onClick: function() {
            return setShowPassword(function(s) {
                return !s;
            });
        },
        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeconSVG/* EyeconSVG */.C, {
            className: "fill-current text-gray-800"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeconClosedSVG/* EyeconClosedSVG */._, {
            className: "absolute right-0 top-0 bottom-0"
        })
    });
    var controls = (0,use_animation/* useAnimation */._)();
    (0,react.useEffect)(function() {
        if (hover) {
            controls.start({
                width: "100%"
            });
        } else {
            controls.start({
                width: "0%"
            });
        }
        return function() {
            return controls.stop();
        };
    }, [
        hover,
        controls
    ]);
    var emailError = emailServerError || handleError("email", formik);
    var passwordError = passwordServerError || handleError("password", formik);
    var ref6 = groupErrors({
        isError: mutate.isError,
        errors: (ref = mutate.error) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1.map(function(m) {
            return m === null || m === void 0 ? void 0 : m.message;
        })
    }, {
        isError: !!error,
        errors: Array.isArray(error) ? error : [
            error
        ]
    }), hasError = ref6.hasError, errorsList = ref6.errorsList;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative h-screen overflow-y-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* TitleAndTags */.x5, {
                title: "Login"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "pt-10 px-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center justify-between px-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipperTextLogo/* SkipperTextLogo */.C, {
                        href: "https://skipper.io"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative pt-10 h-full ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "z-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "retlative px-20 py-12 bg-white rounded-sm z-10 shadow-md border border-gray-100 w-full max-w-xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-5xl text-passport font-inter font-bold mb-4 text-center",
                                            children: "Log into Skipper!"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center mt-4 text-base text-hardgray font-bold font-inter",
                                        children: "Log in with"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-4 mb-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            onClick: function() {
                                                return signinOauth.mutate({
                                                    type: "signin",
                                                    provider: "google"
                                                });
                                            },
                                            className: "w-full mx-auto flex justify-center col-span-1 text-center border-gray-300 border px-4 py-4 rounded-sm hover:ring-2 hover:ring-passport cursor-pointer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleSVG, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative flex justify-center items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute left-0 right-0 h-0.5 bg-gray-300"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bg-white py-1 px-4 z-10 text-base font-inter text-gray-500",
                                                children: "or"
                                            })
                                        ]
                                    }),
                                    hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAnnouncement/* ErrorAnnouncement */.u, {
                                        title: "Signin failed",
                                        list: errorsList
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: formik.handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* InputGroup */.BZ, {
                                                        id: "email",
                                                        name: "email",
                                                        labelText: "Email or Username",
                                                        labelClassName: "font-bold font-inter text-gray-400",
                                                        className: "mb-2 ".concat(emailError ? "border-red-600" : ""),
                                                        onChange: formik.handleChange,
                                                        value: formik.values.email
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* InputGroup */.BZ, {
                                                        type: "".concat(showPassword ? "text" : "password"),
                                                        id: "password",
                                                        name: "password",
                                                        labelText: "Password",
                                                        labelClassName: "font-bold font-inter text-gray-400",
                                                        className: "".concat(passwordError ? "border-red-600" : ""),
                                                        rightIcon: Eyecon,
                                                        onChange: formik.handleChange,
                                                        value: formik.values.password
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-wrap gap-y-2 items-center justify-start md:justify-between mt-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "pt-2 sm:pt-1 text-gray-400",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* Checkbox */.XZ, {
                                                            setChecked: formik.handleChange,
                                                            checked: formik.values.rememberMe,
                                                            srLabel: "remember me",
                                                            id: "rememberMe",
                                                            label: "Remember Me",
                                                            labelBold: "",
                                                            labelClassName: "text-gray-400 font-bold z-10",
                                                            name: "rememberMe"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/auth/password/new",
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "text-gray-400 font-bold hover:text-passport z-10 cursor-pointer",
                                                            children: "Forgot your password?"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* Button */.zx, {
                                                variant: "secondary",
                                                size: "large",
                                                type: "submit",
                                                className: "w-full text-center rounded-full flex items-center justify-center mt-6",
                                                disabled: mutate.isLoading,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-xl font-inter font-bold",
                                                    children: "".concat(mutate.isLoading ? "Signing In..." : "Log in")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative z-20 w-full flex items-center justify-center mt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            ref: container,
                            className: "group relative ",
                            onMouseEnter: function() {
                                return setHover(true);
                            },
                            onMouseLeave: function() {
                                return setHover(false);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://skipper.io/privacy",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "block z-20 text-teal-600 font-bold",
                                    children: "View our Privacy Policy"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                    animate: controls,
                                    layout: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full h-1 bg-teal-400"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WaveSVG/* Wave */.i, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 13471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ encodeQueryData; }
/* harmony export */ });
function encodeQueryData(data) {
    var values = [];
    for(var k in data){
        values.push("".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(data[k])));
    }
    return values.length > 0 ? "?".concat(values.join("&")) : "";
}


/***/ }),

/***/ 34954:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function ExclamationCircleIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ExclamationCircleIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// UNUSED EXPORTS: useAnimationControls

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimationControls() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}
var useAnimation = useAnimationControls;




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(28208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);